import MapHandler from './map-handler'

export default class Handler {

    map;

    constructor() {
        this.map = new MapHandler();
    }
}